import {Projeto} from "./Projeto";
import {Column, Entity, ManyToOne, PrimaryGeneratedColumn} from "typeorm";
import {JoinColumn} from "typeorm/browser";
import {Entidade} from "./Entidade";

@Entity("campanha")
export class Campanha  extends Entidade{
  @Column({nullable: false})
  nome?: string
  @Column({type: "date"})
  inicio?: Date
  @Column({type: "date"})
  fim?: Date
  @ManyToOne(() => Projeto, (projeto) => projeto.campanhas)
  @JoinColumn({name: "projeto_id"})
  projeto?: Projeto
  @Column()
  agencia_sigla?: string
}
